import { useEffect, useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { Dropdown, Button, Form, Col, Row, Nav, Table } from "react-bootstrap";
import { Search, XLg, ThreeDotsVertical } from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import TableDesign from "../../common/table/TableDesign";
import download from "../../../assets/images/download.png";
import editIcon from "../../../assets/images/mega_edit.png";
import moment from "moment";
import Loader from "../../common/loader/Loader";
import ManageImc from "./ManageImc";
import {
  downLoadImcReportDatewise,
  downLoadImcReportInCSVDatewise,
  downLoadImcReportInXLXDatewise,
  fetchImcList,
  sendImcReportToShrewd,
} from "../../../store/actions/imcAction";
import ApiResponsePopup from "../../common/modal/ApiResponsePopup";
import { resetPopup } from "../../../store/reducerSlice/imc";
import ImcAutoSchedule from "./ImcAutoSchedule";
const tableHeadings = [
  // {
  //   label: "S. No.",
  // },
  {
    label: "Action",
  },
  {
    label: "Last Updated",
  },
  {
    label: "Ward",
  },
  {
    label: "Bed Type",
  },
  {
    label: "Provider",
  },

  {
    label: "Total Beds",
    whiteSpace: "text-wrap",
  },

  {
    label: (
      <>
        Total Occupied /<br />
        Allocated Beds
      </>
    ),
    whiteSpace: "no-wrap",
  },

  {
    label: (
      <>
        Escalation <br />
        Beds <br />
        in use
      </>
    ),
    whiteSpace: "no-wrap",
  },
  {
    label: "Closed Beds",
    whiteSpace: "text-wrap",
  },
  {
    label: "Available Beds",
    whiteSpace: "text-wrap",
  },
  {
    label: (
      <>
        Patients not <br />
        meeting
        <br /> Criteria to
        <br /> Reside
      </>
    ),
    whiteSpace: "no-wrap",
  },
  {
    label: "Confirmed Admissions (Today)",
    whiteSpace: "text-wrap",
  },
  {
    label: "Confirmed Admissions (Tomorow)",
    whiteSpace: "text-wrap",
  },
  {
    label: "Confirmed Discharges (Today)",
    whiteSpace: "text-wrap",
  },
  {
    label: "Pending Discharges (Tomorrow)",
    whiteSpace: "text-wrap",
  },
];

const ImcList = ({ tabValue, setTabValue }) => {
  const [show, setShow] = useState(false);

  const handleShow = () => {
    setShow(true);
  };
  const [modalShow, setModalShow] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [selectUcrt, setSelectUcrt] = useState(null);
  const [imcList, setImcList] = useState();
  const [message, setMessage] = useState(null);
  const [title, setTitle] = useState(null);
  const [showResult, setShowResult] = useState(false);
  const [searchText, setSearchText] = useState();

  const [deleteRec, setDeleteRec] = useState(null);

  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [workForceLinkModalShow, setWorkForceLinkModalShow] = useState(false);
  const [toggleActivateRec, setToggleActivateRec] = useState(null);

  const [toggleActivateModalShow, setToggleActivateModalShow] = useState(false);
  // Utility to format date from YYYY-MM-DD to DD-MM-YYYY
  const formatDateDDMMYYYY = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };
  const [modalUcrtShow, setModalUcrtShow] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [downloadType, setDownloadType] = useState("xlsx");
  const [selectedDate, setSelectedDate] = useState(
    moment(new Date()).format("YYYY-MM-DD"),
  );
  const [selectedToDate, setSelectedToDate] = useState(
    moment().format("YYYY-MM-DD"),
  );
  const [selectedFromDate, setSelectedFromDate] = useState(
    moment().subtract(30, "d").format("YYYY-MM-DD"),
  );
  const [startDate, setStartDate] = useState(
    moment().subtract(30, "d").format("YYYY-MM-DD"),
  );
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [filterOption, setFilterOption] = useState({
    startDate: startDate,
    endDate: endDate,
    page: 1,
    limit: 7,
    orderBy: "createdAt",
    orderIn: -1,
  });
  const handleClose = () => {
    setShow(false);
    setDownloadType("xlsx");
    setSelectedFromDate(moment().subtract(30, "d").format("YYYY-MM-DD"));
    setSelectedToDate(moment().format("YYYY-MM-DD"));
  };
  const {
    imcs,
    filtered,
    pagination,
    isLoader,
    isRecordUpdated,
    sendToShrewdResponse,
    isSendToShrewdClicked,
    downloadFileOfDate,
    downloadFileOfCurrentDate,
    downloadXlsxFileOfDate,
    downloadCsvFileOfDate,
    isDownloadLoader,
    isRecordAdded,
    error: apiError,
  } = useSelector((state) => {
    return state.imcs;
  });
  useEffect(() => {
    dispatch(
      fetchImcList({
        startDate: startDate,
        endDate: endDate,
        limit: 7,
      }),
    ).then(({ payload }) => {
      console.log("payload", payload);
      if (payload.success) {
        setImcList(payload?.data?.imcs);
        hideHandlerRes();
      } else {
        setIsShow(true);
      }
    });
  }, [startDate, endDate]);

  const hideHandlerRes = () => {
    setIsShow(false);
    dispatch(resetPopup());
  };

  console.log("imcs imcList", sendToShrewdResponse);

  const cc = filtered || imcs;

  const downloadCC = downloadFileOfCurrentDate || downloadFileOfDate || imcs;

  useEffect(() => {
    if (searchText || searchText === "") {
      filterHandler({
        startDate: startDate,
        endDate: endDate,
        search: searchText,
        page: 1,
        limit: 7,
      });
    }
  }, [searchText]);
  window.history.replaceState({}, document.title);

  useEffect(() => {
    if (!location?.state?.previousActiveTab) {
      const updatedFilterOption = {
        ...filterOption,
        startDate,
        endDate,
      };
      dispatch(fetchImcList(updatedFilterOption));
    }
  }, [filterOption, isRecordUpdated]);

  const filterHandler = (obj) => {
    setFilterOption({
      ...filterOption,
      ...obj,
    });
  };

  const hideHandle = () => {
    setModalShow(false);
    setSelectUcrt(null);
    setDeleteModalShow(false);
    setDeleteRec(null);
    setToggleActivateModalShow(false);
    setToggleActivateRec(null);
    setWorkForceLinkModalShow(false);
    setModalUcrtShow(false);
  };

  const getDatesBetween = (startDate, endDate) => {
    const dates = [];
    const currentDate = new Date(startDate);
    const lastDate = new Date(endDate);

    while (currentDate <= lastDate) {
      dates.push(currentDate.toISOString().split("T")[0]);
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return dates;
  };

  const formatedDate = (val) => {
    var options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour12: true,
    };
    return new Date(val).toLocaleDateString("nl-NL", options);
  };
  const formatedTime = (val) => {
    var options = { hour12: true, hour: "2-digit", minute: "2-digit" };
    return new Date(val).toLocaleTimeString("en-US", options);
  };

  //  Report Navigate
  const navigateReport = () => {
    navigate("/ucrt-reports");
  };

  //  Ucrt Navigate
  const navigateUcrtModule = () => {
    navigate("/ucrt-module");
  };
  const addNewUCRT = () => {
    dispatch(resetPopup());
    setModalUcrtShow(true);

    setTitle("Add IMC/Stroke");
    setMessage("IMC/Stroke has been added successfully.");
    setShowResult(true);
  };
  const createUpdateUcrt = (row) => {
    console.log("row", row);
    setModalUcrtShow(true);
    setSelectUcrt(row);
  };
  const [scrollTable, setScrollTable] = useState(false);
  const handleScrollButtonClick = () => {
    setScrollTable(!scrollTable);
  };

  useEffect(() => {
    console.log("selectedDate", selectedDate);
    if (
      selectedDate ||
      selectedDate === moment(new Date()).format("YYYY-MM-DD")
    ) {
      dispatch(downLoadImcReportDatewise({ dateData: selectedDate }));
    }
  }, [selectedDate]);

  useEffect(() => {
    if (selectedFromDate && selectedToDate && show && downloadType) {
      const dateArray = getDatesBetween(selectedFromDate, selectedToDate);
      if (downloadType === "xlsx") {
        dispatch(
          downLoadImcReportInXLXDatewise({
            dateArray,
          }),
        );
      } else {
        dispatch(
          downLoadImcReportInCSVDatewise({
            dateArray,
          }),
        );
      }
    }
  }, [selectedFromDate, selectedToDate, show, downloadType]);

  const handleToSendToShrewd = () => {
    dispatch(sendImcReportToShrewd());
  };

  return (
    <>
      {(isDownloadLoader || isLoader) && <Loader />}
      {/* Model csv/xls download date wise report */}
      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <h4 style={{ flex: "auto", textAlign: "center" }}>
            Date Wise {downloadType === "xlsx" ? "Excel" : "CSV"} Report
          </h4>
        </Modal.Header>
        <Modal.Body>
          {/* Date Range */}
          <Form className="px-4 py-2 " style={{ boxShadow: "none" }}>
            <div className="row">
              <div className="col-md-6">
                <Form.Label>From Date</Form.Label>
                <Form.Control
                  type="date"
                  max={moment(new Date()).format("YYYY-MM-DD")}
                  value={selectedFromDate}
                  onChange={(e) => {
                    const newFrom = e.target.value;
                    let newTo = selectedToDate;
                    // If new From Date is after current To Date, set To Date to new From Date (or max 30 days ahead, or today)
                    if (moment(newFrom).isAfter(moment(selectedToDate))) {
                      const maxTo = moment(newFrom).add(30, "days");
                      const today = moment();
                      newTo = maxTo.isAfter(today)
                        ? today.format("YYYY-MM-DD")
                        : maxTo.format("YYYY-MM-DD");
                      setSelectedToDate(newTo);
                    } else if (
                      moment(selectedToDate).diff(moment(newFrom), "days") > 30
                    ) {
                      // If current To Date is more than 30 days after new From Date, adjust it
                      const newToLimit = moment(newFrom)
                        .add(30, "days")
                        .format("YYYY-MM-DD");
                      setSelectedToDate(
                        newToLimit > moment().format("YYYY-MM-DD")
                          ? moment().format("YYYY-MM-DD")
                          : newToLimit,
                      );
                    }
                    setSelectedFromDate(newFrom);
                  }}
                />
              </div>

              <div className="col-md-6">
                <Form.Label>To Date</Form.Label>
                <Form.Control
                  type="date"
                  min={selectedFromDate}
                  max={(() => {
                    const maxBy30 = moment(selectedFromDate)
                      .add(30, "days")
                      .format("YYYY-MM-DD");
                    const today = moment().format("YYYY-MM-DD");
                    return maxBy30 < today ? today : maxBy30;
                  })()}
                  value={selectedToDate}
                  onChange={(e) => {
                    let newTo = e.target.value;
                    // If new To Date is more than 30 days after From Date, adjust From Date
                    if (
                      moment(newTo).diff(moment(selectedFromDate), "days") > 30
                    ) {
                      const newFrom = moment(newTo)
                        .subtract(30, "days")
                        .format("YYYY-MM-DD");
                      setSelectedFromDate(newFrom);
                    }
                    setSelectedToDate(newTo);
                  }}
                />
              </div>
            </div>
          </Form>
          {(isDownloadLoader || isLoader) && <Loader />}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            {/* Download All ZIP */}
            {downloadType === "xlsx" &&
              downloadXlsxFileOfDate?.allFilesZipPath &&
              !apiError && (
                <a
                  href={downloadXlsxFileOfDate.allFilesZipPath}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-success w-20 float-right"
                >
                  Download All
                </a>
              )}
            {downloadType === "csv" &&
              downloadCsvFileOfDate?.allFilesZipPath &&
              !apiError && (
                <a
                  href={downloadCsvFileOfDate.allFilesZipPath}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-success w-20 float-right"
                >
                  Download All
                </a>
              )}
          </div>
          {/* Table xlx */}
          {downloadType === "xlsx" &&
            downloadXlsxFileOfDate?.filesByTimesArray?.length > 0 &&
            !apiError && (
              <Table bordered hover responsive className="mt-2 px-4">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {downloadXlsxFileOfDate?.filesByTimesArray?.map(
                    (item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{formatDateDDMMYYYY(item.date)}</td>
                        <td>
                          <a
                            href={item.filePath}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-sm btn-primary"
                          >
                            Download
                          </a>
                        </td>
                      </tr>
                    ),
                  )}
                </tbody>
              </Table>
            )}
          {/* Table csv */}
          {downloadType === "csv" &&
            downloadCsvFileOfDate?.filesByTimesArray?.length > 0 &&
            !apiError && (
              <Table bordered hover responsive className="mt-4 px-4">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {downloadCsvFileOfDate?.filesByTimesArray?.map(
                    (item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{formatDateDDMMYYYY(item.date)}</td>
                        <td>
                          <a
                            href={item.filePath}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-sm btn-primary"
                          >
                            Download
                          </a>
                        </td>
                      </tr>
                    ),
                  )}
                </tbody>
              </Table>
            )}

          {apiError && (
            <p className="text-danger text-center mt-3">{apiError?.message}</p>
          )}
        </Modal.Body>

        <Modal.Footer className="d-flex flex-column gap-3">
          <span
            className="cancel-btn cursor-pointer"
            onClick={() => {
              handleClose();
              setDownloadType("xlsx");
            }}
          >
            Cancel
          </span>
        </Modal.Footer>
      </Modal>

      {/* Modal Download Date wise report */}
      {/* <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          {" "}
          <h4 align="center" style={{ textAlign: "center", flex: "auto" }}>
            Date Wise Report
          </h4>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3 px-5">
            <Form.Label>Date of the Report</Form.Label>
            <Form.Control
              type="date"
              onKeyDown={(e) => {
                e.preventDefault();
              }}
              placeholder="select"
              defaultValue={moment(new Date()).format("YYYY-MM-DD")}
              max={moment(new Date()).format("YYYY-MM-DD")}
              autoFocus
              onChange={async (e) => {
                setSelectedDate(e.target.value);
              }}
            />
          </Form.Group>
          {isDownloadLoader && <Loader />}
        </Modal.Body>
        <Modal.Footer className="d-flex flex-column justify-content-center">
          {downloadFileOfDate && !apiError && (
            <a
              className="downloadBtn rounded cursor-pointer"
              href={downloadFileOfDate}
              target="_blank"
            >
              <img src={download} alt="img" /> Download Report
            </a>
          )}
          {apiError && <p className="textWarning">{apiError?.message}</p>}

          <span
            className="cancel-btn mt-4 cursor-pointer"
            onClick={handleClose}
          >
            Cancel
          </span>
        </Modal.Footer>
      </Modal> */}
      {/* End Model */}
      {/* End Model */}

      <ManageImc
        show={modalUcrtShow}
        onHide={hideHandle}
        title={
          selectUcrt
            ? `IMC/Stroke (${moment().format("LL")})`
            : `IMC/Stroke (${moment().format("LL")})`
        }
        selectRow={selectUcrt}
        setModalUcrtShow={setModalUcrtShow}
      />

      <h1 className="main-title-imc">IMC/Stroke</h1>

      <div
        className="block-section"
        style={{ padding: "10px 16px", marginTop: "0px" }}
      >
        <Button
          className={`${
            tabValue === "0" ? "btn-primary" : "outline-primary me-4 reportBtn"
          } me-4 reportBtn`}
          variant="outline-primary"
          onClick={() => setTabValue("0")}
        >
          IMC/Stroke
        </Button>

        <Button
          className={`${
            tabValue === "1" ? "btn-primary" : "outline-primary me-4 reportBtn"
          } me-4 reportBtn`}
          variant="outline-primary"
          onClick={() => setTabValue("1")}
        >
          Daily IMC/Stroke Reports
        </Button>
      </div>
      <div className="container custom-container">
        {tabValue === "0" && (
          <>
            <TableDesign
              className="mt-2 pt-4"
              {...{
                title: "List of IMC/Stroke",
                filterSection: (
                  <>
                    {/* <div
                      className="date-group"
                      style={{ float: "right", paddingLeft: "16px" }}
                    > */}
                    <Form.Group style={{ marginRight: "10px" }}>
                      <Form.Label>Start Date</Form.Label>
                      <Form.Control
                        type="date"
                        timeFormat="YYYY-MM-DD"
                        onKeyDown={(e) => {
                          e.preventDefault();
                        }}
                        placeholder="Select"
                        autoFocus
                        name="start_date"
                        style={{
                          height: "30px",
                        }}
                        max={new Date().toISOString().slice(0, 10)}
                        defaultValue={startDate}
                        onChange={(e) => {
                          setStartDate(e.target.value);
                        }}
                      />
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>End Date</Form.Label>
                      <Form.Control
                        type="date"
                        onKeyDown={(e) => {
                          e.preventDefault();
                        }}
                        placeholder="Select"
                        autoFocus
                        style={{
                          height: "30px",
                        }}
                        name="end_date"
                        min={startDate}
                        max={moment().format("YYYY-MM-DD")}
                        defaultValue={endDate}
                        onChange={(e) => {
                          setEndDate(e.target.value);
                        }}
                      />
                    </Form.Group>
                    {/* </div> */}
                  </>
                ),
                tableHeadings,
                filterHandler,
                pagination,
                filterOption,
                setFilterOption,
                isLoader,
              }}
            >
              {/* {isLoader && <Loader />} */}
              {cc && cc.length ? (
                cc.map((row, i) => {
                  if (row) {
                    const isSameDate =
                      moment(row.createdAt).format("YYYY-MM-DD") ===
                      moment().format("YYYY-MM-DD");
                    const isSameDateTime = moment(row.createdAt).isSame(
                      moment(row.updatedAt),
                    );

                    const previousRow = cc.find(
                      (prevRow) =>
                        prevRow._id === row._id &&
                        moment(prevRow.updatedAt).isBefore(row.updatedAt),
                    );
                    return (
                      <tr key={i} className="align-items-center">
                        {/* <td align="center">
                      {i + 1 + (page > 1 && (page - 1) * 10)}
                    </td> */}
                        <td align="center">
                          <>
                            {moment(row.createdAt).format("YYYY-MM-DD") ===
                              moment().format("YYYY-MM-DD") &&
                            row?.isEditable ? (
                              <>
                                {!isSameDateTime ? (
                                  <img
                                    src={editIcon}
                                    style={{
                                      height: "16px",
                                      width: "16px",
                                      cursor: "pointer",
                                    }}
                                    alt="edit"
                                    onClick={() => createUpdateUcrt(row)}
                                  />
                                ) : (
                                  <img
                                    src={editIcon}
                                    alt="edit"
                                    style={{
                                      height: "16px",
                                      width: "16px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      createUpdateUcrt(
                                        previousRow ? previousRow : row,
                                      )
                                    }
                                  />
                                )}
                              </>
                            ) : (
                              <></>
                            )}
                          </>
                        </td>
                        <td align="center">
                          {formatedDate(row.updatedAt)}, <br />
                          {formatedTime(row.updatedAt)}
                        </td>
                        <td align="left" style={{ whiteSpace: "nowrap" }}>
                          {row?.ward}
                        </td>
                        <td align="center">{row?.bedTypes}</td>
                        <td align="center">{row?.provider}</td>
                        <td align="center">{row?.totalBeds}</td>
                        <td align="center">{row?.occupiedBeds}</td>
                        <td align="center">{row?.escalationBeds}</td>
                        <td align="center">{row?.closedBeds}</td>
                        <td align="center">{row?.availableBeds}</td>
                        <td align="center">{row?.patientCriteria}</td>
                        <td align="center">{row?.confirmedAdmissionsToday}</td>
                        <td align="center">
                          {row?.confirmedAdmissionsTomorrow}
                        </td>
                        <td align="center">{row?.confirmedDischargesToday}</td>
                        <td align="center">{row?.pendingDischargesTomorrow}</td>
                      </tr>
                    );
                  }
                })
              ) : (
                <tr>
                  <td colSpan="15">No Result Found</td>
                </tr>
              )}
              {cc && cc.length > 0 && (
                <tr
                  className="align-items-center"
                  style={{ fontWeight: "bold", backgroundColor: "#f0f0f0" }}
                >
                  <td align="center"></td>
                  <td align="center"></td>
                  <td align="left" style={{ whiteSpace: "nowrap" }}>
                    Total
                  </td>
                  <td align="center"></td>
                  <td align="center"></td>
                  <td align="center">
                    {cc.reduce((sum, row) => sum + (Number(row?.totalBeds) || 0), 0)}
                  </td>
                  <td align="center">
                    {cc.reduce((sum, row) => sum + (Number(row?.occupiedBeds) || 0), 0)}
                  </td>
                  <td align="center">
                    {cc.reduce((sum, row) => sum + (Number(row?.escalationBeds) || 0), 0)}
                  </td>
                  <td align="center">
                    {cc.reduce((sum, row) => sum + (Number(row?.closedBeds) || 0), 0)}
                  </td>
                  <td align="center">
                    {cc.reduce((sum, row) => sum + (Number(row?.availableBeds) || 0), 0)}
                  </td>
                  <td align="center">
                    {cc.reduce((sum, row) => sum + (Number(row?.patientCriteria) || 0), 0)}
                  </td>
                  <td align="center">
                    {cc.reduce((sum, row) => sum + (Number(row?.confirmedAdmissionsToday) || 0), 0)}
                  </td>
                  <td align="center">
                    {cc.reduce((sum, row) => sum + (Number(row?.confirmedAdmissionsTomorrow) || 0), 0)}
                  </td>
                  <td align="center">
                    {cc.reduce((sum, row) => sum + (Number(row?.confirmedDischargesToday) || 0), 0)}
                  </td>
                  <td align="center">
                    {cc.reduce((sum, row) => sum + (Number(row?.pendingDischargesTomorrow) || 0), 0)}
                  </td>
                </tr>
              )}
            </TableDesign>
          </>
        )}
      </div>
      {tabValue === "1" && (
        <section className="overflow-hidden">
          <div className="block-section">
            <p className="txtHeading">You can download the IMC/Stroke report</p>
            <div className="d-flex align-items-center mt-4">
              <Dropdown>
                <Dropdown.Toggle
                  variant="success"
                  id="dropdown-download"
                  style={{ fontWeight: 600 }}
                >
                  <img
                    src={download}
                    style={{ marginRight: "6px" }}
                    alt="img"
                  />
                  Download Report
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    onClick={() => {
                      setDownloadType("xlsx");
                      handleShow();
                    }}
                  >
                    Download as Excel
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      setDownloadType("csv");
                      handleShow();
                    }}
                  >
                    Download as CSV
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              <Button
                className="btn-primary btn-primary reportBtn ms-4"
                style={{ background: "#f6a04c", color: "#fff" }}
                onClick={handleToSendToShrewd}
              >
                Send To Shrewd Now
              </Button>
            </div>
          </div>
          <ImcAutoSchedule />
        </section>
      )}

      {isSendToShrewdClicked && (
        <ApiResponsePopup
          {...{
            hideHandlerRes,
            isRecordAdded: isSendToShrewdClicked,
            title: "Alert",
            successMsg:
              sendToShrewdResponse?.message || "Report emailed successfully.",
            errorRes: apiError?.message,
          }}
        />
      )}
    </>
  );
};

export default ImcList;
